import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProspectusComponent } from './components/prospectus/prospectus.component';
import { prospectusTabResolver } from './resolvers/prospectus-tab.resolver';
import { FundType } from './models/fund-type.enum';
import { AppConstants } from './util/app.constants';
import { ErrorComponent } from './components/error/error.component';
import { ApplicationType } from './models/application-type.enum';
import { TailoredShareholdersComponent } from './components/tailored-shareholders/tailored-shareholders.component';


const routes: Routes = [
  {
    path: 'prospectus/funds',
    redirectTo: 'prospectus/sec',
    pathMatch: 'full'
  },
  {
    path: 'prospectus/funds-workplace',
    redirectTo: 'prospectus/sec',
    pathMatch: 'full'
  },
  {
    path: 'prospectus/sec',
    component: TailoredShareholdersComponent,
    resolve: {fundType: prospectusTabResolver},
    data: {
      title: AppConstants.TAILORED_SHAREHOLDERS_TITLE,
      description: AppConstants.TAILORED_SHAREHOLDERS_DESCRIPTION,
      renderNavBar: true,
      disclosures: AppConstants.TAILORED_SHAREHOLDERS_DISCLOSURES,
      applicationId: ApplicationType.RETAIL
    },
  },
  {
    path: 'prospectus/sec-annuities',
    redirectTo: 'prospectus/sec',
    pathMatch: 'full'
  },
  {
    path: 'prospectus/annuities',
    component: ProspectusComponent,
    resolve: {family: prospectusTabResolver},
    data: {
      title: AppConstants.DEFAULT_TITLE,
      renderNavBar: true,
      applicationId: ApplicationType.FILI,
      description: AppConstants.ANNUITIES_DESCRIPTION,
      disclosures: AppConstants.ANNUITIES_DISCLOSURES
    },
  },
  {
    path: 'error',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}